import React from "react";

interface ContactUsComponentProps {}

export const ContactUsComponent: React.FC<ContactUsComponentProps> = (
  props: ContactUsComponentProps
) => {
  return (
    <div className="py-16 text-center">
      <h1 className="text-gray-600">Contact us page coming soon</h1>
    </div>
  );
};
